import styled from "@emotion/styled";
import { noop } from "lodash";
import * as React from "react";

import { Table, Th } from "components/table";
import { IInvoice } from "interfaces/entities/invoice";
import { contentPaddingSmallValue } from "routes/styled";

import { SubscriptionInvoicesPagination } from "./SubscriptionInvoicesPagination";
import SubscriptionInvoicesTableRow from "./SubscriptionInvoicesTableRow";

interface IProps {
  invoices: IInvoice[];
}

const Wrapper = styled.div`
  margin: 0 -${contentPaddingSmallValue}px;
`;

export const SubscriptionInvoicesTable: React.FC<IProps> = ({ invoices }) => (
  <Wrapper>
    <SubscriptionInvoicesPagination currentPage={1} totalPages={1} totalResults={invoices.length} onPageChange={noop} />

    <Table
      thead={
        <thead>
          <tr>
            <Th>Date</Th>
            <Th>Description</Th>
            <Th>Payment</Th>
            <Th>Status</Th>
            <Th>Download</Th>
          </tr>
        </thead>
      }
      tbody={
        <tbody>
          {invoices.map(invoice => (
            <SubscriptionInvoicesTableRow key={invoice.id} invoice={invoice} />
          ))}
        </tbody>
      }
    />
  </Wrapper>
);
